/**
 * AvatarItem Styles
 * Gamified card-style cells: soft shadow, selected glow
 * 3 columns on mobile, 4 columns on large screens
 */

import { StyleSheet, Dimensions } from 'react-native';
import { theme } from '../../../theme';

const { width: screenWidth } = Dimensions.get('window');
const isLargeScreen = screenWidth >= 600;
/** 3 columns on mobile (~31.5%), 4 columns on large screens (~23%) */
const ITEM_WIDTH_PERCENT = isLargeScreen ? '23%' : '31.5%';

export const avatarItemStyles = StyleSheet.create({
  avatarItem: {
    width: ITEM_WIDTH_PERCENT,
    aspectRatio: 1,
    padding: 8,
    marginBottom: 12,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 16,
    borderWidth: 2,
    borderColor: 'transparent',
    backgroundColor: theme.background.cardElevated,
    overflow: 'hidden',
    shadowColor: theme.shadow,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.12,
    shadowRadius: 6,
    elevation: 3,
  },
  avatarItemSelected: {
    borderColor: theme.primary,
    borderWidth: 3,
    backgroundColor: theme.primary + '20',
    transform: [{ scale: 1.08 }],
    shadowColor: theme.primary,
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.4,
    shadowRadius: 10,
    elevation: 6,
  },
  avatarItemPressed: {
    opacity: 0.8,
  },
  avatarItemHover: {
    opacity: 0.9,
  },
});
